module.exports = __webpack_public_path__ + "media/src/assets/images/riwi-b1830d0281c1c547310e0e160dc91e5d.svg";